/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_CrumbInputs */

const en_portalsignin_crumb = /** @type {(inputs: Portalsignin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

/** @type {(inputs: Portalsignin_CrumbInputs) => LocalizedString} */
const ar_portalsignin_crumb = en_portalsignin_crumb;

/** @type {(inputs: Portalsignin_CrumbInputs) => LocalizedString} */
const he_portalsignin_crumb = en_portalsignin_crumb;

/** @type {(inputs: Portalsignin_CrumbInputs) => LocalizedString} */
const ur_portalsignin_crumb = en_portalsignin_crumb;

/** @type {(inputs: Portalsignin_CrumbInputs) => LocalizedString} */
const es_portalsignin_crumb = en_portalsignin_crumb;

/** @type {(inputs: Portalsignin_CrumbInputs) => LocalizedString} */
const fr_portalsignin_crumb = en_portalsignin_crumb;

/** @type {(inputs: Portalsignin_CrumbInputs) => LocalizedString} */
const de_portalsignin_crumb = en_portalsignin_crumb;

/** @type {(inputs: Portalsignin_CrumbInputs) => LocalizedString} */
const pt_portalsignin_crumb = en_portalsignin_crumb;

/** @type {(inputs: Portalsignin_CrumbInputs) => LocalizedString} */
const hi_portalsignin_crumb = en_portalsignin_crumb;

/** @type {(inputs: Portalsignin_CrumbInputs) => LocalizedString} */
const bn_portalsignin_crumb = en_portalsignin_crumb;

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Portalsignin_CrumbInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_crumb = /** @type {((inputs?: Portalsignin_CrumbInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_CrumbInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_crumb(inputs)
	if (locale === "he") return he_portalsignin_crumb(inputs)
	if (locale === "ur") return ur_portalsignin_crumb(inputs)
	if (locale === "es") return es_portalsignin_crumb(inputs)
	if (locale === "fr") return fr_portalsignin_crumb(inputs)
	if (locale === "de") return de_portalsignin_crumb(inputs)
	if (locale === "pt") return pt_portalsignin_crumb(inputs)
	if (locale === "hi") return hi_portalsignin_crumb(inputs)
	if (locale === "bn") return bn_portalsignin_crumb(inputs)
	return /** @type {LocalizedString} */ ("Sign in")
});